import { render, staticRenderFns } from "./OrganisationIndividualAdd.vue?vue&type=template&id=3707d0e4&scoped=true&"
import script from "./OrganisationIndividualAdd.vue?vue&type=script&lang=ts&"
export * from "./OrganisationIndividualAdd.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationIndividualAdd.vue?vue&type=style&index=0&id=3707d0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707d0e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3707d0e4')) {
      api.createRecord('3707d0e4', component.options)
    } else {
      api.reload('3707d0e4', component.options)
    }
    module.hot.accept("./OrganisationIndividualAdd.vue?vue&type=template&id=3707d0e4&scoped=true&", function () {
      api.rerender('3707d0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationIndividualAdd.vue"
export default component.exports